import { render, staticRenderFns } from "./joint-creator.vue?vue&type=template&id=790d42ea&scoped=true&"
import script from "./joint-creator.vue?vue&type=script&lang=js&"
export * from "./joint-creator.vue?vue&type=script&lang=js&"
import style0 from "./joint-creator.vue?vue&type=style&index=0&id=790d42ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d42ea",
  null
  
)

export default component.exports